import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyleConnexion = makeStyles((theme) => createStyles({
    paperClass: {
        padding: theme.spacing(4),
        // height: "70vh"
        background: "#E5E9EC",
    },
    linkStyle: {
        cursor: "pointer",
        color: "rgba(0, 0, 0, 1)",
        textDecoration: 'none',
    },
    cardTitle: {
        fontWeight: "bold",
        color: "#888",
    },
    alignTextRight: {
        display: 'inline',
        padding: '8px',
        fontSize: '1rem',
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
        marginTop:7,
    }
}));